'use strict';

const {fillWithShapeOptions} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');
const Fitter = require('../classes/Fitter');

module.exports = new DrawingElement('fitting', function () {
    const select = this.query('select');
    fillWithShapeOptions(select, 5, 20);

    const label = this.query('.current-value');

    const bounds = new Shape.Quadrilateral.Square(Point.origin(), this.width);
    bounds.setAnchorPoint(Point.origin());

    let shape;
    let fitInterval;
    let fitter;

    const drawShape = () => {
        shape = new Shape(parseInt(select.value, 10), Point.origin(), 100);
        shape.scaleToFitWithin(this.width - this.pad * 2, this.width - this.pad * 2);
        shape.centerAgainst(bounds);
        this.wipe();
        shape.draw(this.ctx);
        fitter = new Fitter(0.5);

        if (fitInterval) {
            clearInterval(fitInterval);
            fitInterval = void 0;
        }
        label.innerText = '';
    };

    select.addEventListener('change', drawShape);
    drawShape();

    const drawWithProportion = () => {
        if (!fitter || !shape) return;

        shape.setFractalProportion(fitter.value);
        let subShapes = shape.getProportionalSubShapes();

        this.wipe();
        shape.draw(this.ctx);
        subShapes.forEach((shape) => shape.draw(this.ctx));

        label.innerText = fitter.value;
    };

    const maxIterations = 10000;
    this.query('.fit').addEventListener('click', () => {
        if (!shape) return;

        if (fitInterval) {
            clearInterval(fitInterval);
            fitInterval = void 0;
        }

        fitter = new Fitter(0.5);
        const testingShape = shape.clone();

        let i = 0;
        const iteration = fitter.fitPromiseIterator((proposedValue) => {
            testingShape.setFractalProportion(proposedValue);
            const [shapeA, shapeB] = testingShape.getProportionalSubShapes(2);
            if (shapeA.intersectsWith(shapeB)) {
                return 1;
            } else {
                return -1;
            }
        });

        fitInterval = setInterval(() => {
            if (i++ >= maxIterations) {
                clearInterval(fitInterval);
                fitInterval = void 0;
                return;
            }

            iteration().then(() => {
                drawWithProportion();
            }).catch(() => {
                drawWithProportion();
                clearInterval(fitInterval);
                fitInterval = void 0;
            });
        }, 150);
    });
});


